import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section className="relative min-h-screen w-full bg-stone-50 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="grid grid-cols-12 h-full">
          {[...Array(12)].map((_, i) => (
            <div key={i} className="border-r border-black" />
          ))}
        </div>
      </div>

      {/* Main content */}
      <div className="relative container mx-auto px-6 h-screen flex items-center">
        <div className="w-full flex desktop:flex-row laptop:flex-row tablet:flex-col mobile:flex-col justify-between items-center gap-12">
          {/* Text content */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="desktop:w-1/2 laptop:w-1/2 tablet:w-full mobile:w-full"
          >
            <h1 className="font-light desktop:text-7xl laptop:text-6xl tablet:text-5xl mobile:text-4xl text-stone-900 mb-6">
              coiffure
            </h1>
            <p className="font-light desktop:text-xl laptop:text-xl tablet:text-lg mobile:text-base text-stone-600 mb-8 leading-relaxed">
              Embrace simplicity in style. Our Japanese-inspired approach to
              hair design focuses on clean lines and natural beauty, creating
              harmony between form and function.
            </p>
            <Link
              to="/book"
              className="inline-block px-8 py-3 border border-stone-900 text-stone-900 
                hover:bg-stone-900 hover:text-stone-50 transition-colors duration-300"
            >
              Book Appointment
            </Link>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="desktop:w-1/2 laptop:w-1/2 tablet:w-full mobile:w-full"
          >
            <div className="relative aspect-[3/4] w-full">
              <img
                src="https://placehold.co/800x1000/f5f5f4/1c1917?text=Minimal+Hair+Design"
                alt="Minimal Hair Design"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 border border-stone-900 -translate-x-4 -translate-y-4" />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative elements */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-4"
      >
        <div className="w-[1px] h-16 bg-stone-900" />
        <span className="text-stone-600 font-light rotate-90 origin-center">
          scroll
        </span>
      </motion.div>
    </section>
  );
};

export default Hero;
